import { Component, OnInit } from '@angular/core';
import { Slide, SlideItem } from '../models/Slide';
import { SlideService } from '../services/slide.service';

declare var $: any;


@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.css']
})
export class HeroComponent implements OnInit {

  slides: Slide;
  slideItems: SlideItem[];
  Zhyper: string ="hhhhhhhh"


  view: boolean = true;

  constructor(
    //injectando el Servicio
    private slideService: SlideService
  ) { }

  ngOnInit(): void {

    // JQUERY CODE

    $(document).ready(function () {

      window.onload=function(){
        $('.slider').slick({
        autoplay:true,
        autoplaySpeed:1500,
        arrows:true,
        prevArrow:'<button type="button" class="slick-prev"></button>',
        nextArrow:'<button type="button" class="slick-next"></button>',
        centerMode:true,
        slidesToShow:3,
        slidesToScroll:2
        });
      };


    });


    // ANGULAR CODE

    this.slideService.getSlides()
    .subscribe( (resp) => {
        //this.slidesx = slides
        //console.log(JSON.stringify(this.slidesx))
        this.slideItems = resp
        console.log(resp)
      }
    )

  }

  setView(){
    if (this.view){
      this.view = false
    } else{
      this.view = true
    }
  }

  public onMapReady(event) {
    console.log("Map Ready")
  }

}
